import { render } from "./NotificationLink.vue?vue&type=template&id=5aacf416&ts=true"
import script from "./NotificationLink.vue?vue&type=script&lang=ts"
export * from "./NotificationLink.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__